import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";
import { getDeviceFingerprint } from "../../utils/fingerprint";
import { getAttribution } from "../../utils/attribution";

const submitReservation = async (
    reservationHead,
    items,
    addonItems,
    event,
    type,
    isPwf,
    token,
    preRegister,
    voucherCode = null,
    consent = null,
) => {
    const deviceFingerprint = await getDeviceFingerprint();
    const body = {
        reservationHead,
        event,
        items,
        addonItems,
        type,
        isPwf,
        cart_token: token,
        preRegister: preRegister || null,
        device_fingerprint: deviceFingerprint,
    };
    if (voucherCode) {
        body.voucher_code = voucherCode;
    }
    // Only ever sent as true. The backend rejects an explicit false, and treats
    // an absent flag as implicit acceptance -- which is what an event with no
    // terms configured should record.
    if (consent?.acceptedTerms) {
        body.acceptedTerms = true;
        if (consent.termsVersion) {
            body.termsVersion = consent.termsVersion;
        }
    }
    const attribution = getAttribution();
    if (attribution) {
        body.attribution = attribution;
    }
    const response = await axios.post(
        routes.submitReservation,
        body,
        AXIOS_DEFAULT_CONFIG
    );
    return response;
};
export default submitReservation;